// @ts-ignore
import * as moment from 'moment'

import { LyantheCompanyModel } from './lyanthe.company.model'
import { LyantheContactModel } from './lyanthe.contact.model'
import { LyantheInvoiceLineModel } from './lyanthe.invoice.line.model'
import { LyantheJournalentryModel } from './lyanthe.journalentry.model'
import { forEach } from '@angular/router/src/utils/collection'

export class LyantheInvoiceModel {
  CallbackUrl: string
  eventId: string
  FileName: string
  FileContent: string
  lstPages: string
  rawKofax: string
  invoiceDate: any
  dueDate: any
  paymentRef: string
  invoiceNumber: string
  iban: string
  Status: string
  StatusReason: string
  StatusRemarks: string
  Currency: string
  isCreditNote: boolean
  totalVAT: number
  totalExcl: number
  totalIncl: number
  description: string
  doctype: string
  journalCode: string
  RemarkForBookeeper: string
  duplicate_eventId: string
  EntryNumber: string
  CodeTP: string
  TPDoc: string
  IsPurchase: boolean
  InvoiceID: number

  company: LyantheCompanyModel
  contact: LyantheContactModel
  invoiceLines: LyantheInvoiceLineModel[] = []
  journalEnties: LyantheJournalentryModel[] = []

  constructor(data) {
    this.CallbackUrl = data.CallbackUrl ? data.CallbackUrl : null
    this.eventId = data.eventId ? data.eventId : null
    this.FileName = data.FileName ? data.FileName : null
    this.FileContent = data.FileContent ? data.FileContent : null
    this.lstPages = data.lstPages ? data.lstPages : null
    this.rawKofax = data.rawKofax ? data.rawKofax : null
    this.invoiceDate = data.invoiceDate ? moment(data.invoiceDate) : null
    this.dueDate = data.dueDate ? moment(data.dueDate) : null
    this.paymentRef = data.paymentRef ? data.paymentRef : null
    this.invoiceNumber = data.invoiceNumber ? data.invoiceNumber : null
    this.iban = data.iban ? data.iban : null
    this.Status = data.Status ? data.Status : null
    this.StatusReason = data.StatusReason ? data.StatusReason : null
    this.StatusRemarks = data.StatusRemarks ? data.StatusRemarks : null
    this.Currency = data.Currency ? data.Currency : null
    this.isCreditNote = data.isCreditNote ? data.isCreditNote : null
    this.totalVAT = data.totalVAT ? data.totalVAT : null
    this.totalExcl = data.totalExcl ? data.totalExcl : null
    this.totalIncl = data.totalIncl ? data.totalIncl : null
    this.description = data.description ? data.description : null
    this.doctype = data.doctype ? data.doctype : null
    this.journalCode = data.journalCode ? data.journalCode : null
    this.RemarkForBookeeper = data.RemarkForBookeeper ? data.RemarkForBookeeper : null
    this.duplicate_eventId = data.duplicate_eventId ? data.duplicate_eventId : null
    this.EntryNumber = data.EntryNumber ? data.EntryNumber : null
    this.CodeTP = data.CodeTP ? data.CodeTP : null
    this.TPDoc = data.TPDoc ? data.TPDoc : null
    this.IsPurchase = data.IsPurchase ? data.IsPurchase : null
    this.InvoiceID = data.InvoiceID ? data.InvoiceID : null

    if (data.company) {
      this.company = new LyantheCompanyModel(data.company)
    }

    if (data.contact) {
      this.contact = new LyantheContactModel(data.contact)
    }

    if (data.invoicelines !== null) {
      for (const invoiceline of data.invoicelines) {
        this.invoiceLines.push(new LyantheInvoiceLineModel(invoiceline))
      }
    }

    if (data.journalentries !== null) {
      for (const journalEntry of data.journalentries) {
        this.journalEnties.push(new LyantheJournalentryModel(journalEntry))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/models/lyanthe/lyanthe.invoice.model.ts